<template lang="html">
  <ul class="auto-list">
    <li v-for="(item, index) in objectList" :key="index">
      <AutogrowTextarea v-model="item.value" :autofocus="!disabled && index === 0" :disabled="disabled" :ref="`input-${index}`" type="text" @delete="handleBackspace(index)" @enter="handleEnter(index)" @focus="handleFocus(index)" @input="onInput" @keyup.native.left="handleLeft(index)" @keyup.native.down="handleDown(index)" @keyup.native.right="handleRight(index)" @keyup.native.up="handleUp(index)" />
    </li>
  </ul>
</template>

<script>
import AutogrowTextarea from './AutogrowTextarea.vue';

function cleanObjectArray(objArr) {
  return objArr.map((item) => item.value);
}

export default {
  components: {
    AutogrowTextarea,
  },
  computed: {
    objectList() { // required for v-model
      if (this.value && this.value.length > 0) {
        const tempList = this.value.split('\n');
        const objList = [];
        tempList.forEach((item) => {
          objList.push({ value: item });
        });
        return objList;
      }
      return [{ value: '' }];
    },
  },
  data() {
    return {
      lastLength: -1,
      lastSelection: -1,
    };
  },
  methods: {
    handleBackspace(index) {
      const clone = this.objectList.slice();
      if (this.objectList[index].value.length === 0 && this.lastLength === 0) {
        clone.splice(index, 1);
        this.$emit('input', cleanObjectArray(clone).join('\n'));
        this.$nextTick(() => this.$refs[`input-${Math.max(index - 1, 0)}`][0].focusInput());
      }
      this.lastLength = this.objectList[index].value.length;
    },
    handleDown(index) {
      const { start } = this.$refs[`input-${index}`][0].getSelection();
      if (index < this.objectList.length - 1) this.$nextTick(() => this.$refs[`input-${index + 1}`][0].setSelection(0, -1));
      this.lastSelection = start;
    },
    handleEnter(index) {
      if (this.objectList[index].value.length > 0) {
        const clone = this.objectList.slice();
        clone.splice(index + 1, 0, { value: '' });
        this.$emit('input', cleanObjectArray(clone).join('\n'));
        this.$nextTick(() => this.$refs[`input-${index + 1}`][0].focusInput());
        // We’ll fire a toast warning the user of limited sharing options but allow the full 256c to be used.
      }
    },
    handleFocus(index) {
      this.lastLength = this.objectList[index].value.length;
      this.lastSelection = this.$refs[`input-${index}`][0].getSelection().start;
    },
    handleLeft(index) {
      const { start } = this.$refs[`input-${index}`][0].getSelection();
      if (start === 0 && this.lastSelection === 0 && index > 0) this.$nextTick(() => this.$refs[`input-${index - 1}`][0].setSelection(0, -1));
      this.lastSelection = start;
    },
    handleRight(index) {
      const { start } = this.$refs[`input-${index}`][0].getSelection();
      if (start === this.objectList[index].value.length && this.lastSelection === this.objectList[index].value.length && index < this.objectList.length - 1) this.$nextTick(() => this.$refs[`input-${index + 1}`][0].setSelection(0, -1));
      this.lastSelection = start;
    },
    handleUp(index) {
      const { start } = this.$refs[`input-${index}`][0].getSelection();
      if (index > 0) this.$nextTick(() => this.$refs[`input-${index - 1}`][0].setSelection(0, -1));
      this.lastSelection = start;
    },
    onInput() {
      this.$emit('input', cleanObjectArray(this.objectList).join('\n'));
    },
  },
  props: {
    disabled: Boolean,
    value: String,
  },
};
</script>

<style lang="stylus" scoped>
.auto-list
  margin: 0
  padding-left: 1.2rem
  font-size: 1.1rem
  overflow: auto

  li
    margin-bottom: 0.5rem

</style>
